import { FC } from 'react';
import * as stylex from '@stylexjs/stylex';
import { Button } from '@shared/ui/kit';
import { formatEventDate } from '@shared/libs/format-event-date';
import { styles } from '../../styles';
import check from '../../assets/check.webp';
import { palette } from '@shared/tokens/palette.stylex';
import { ChangeDecisionTrigger } from '../change-decision-trigger';

type AcceptedInviteProps = {
  eventName: string;
  dateStart: string;
  dateEnd: string;
  inviteAcceptionInfo: string;
  onChangeDecision: () => void;
  onOpenTicket?: () => void;
  ticketSent?: boolean;
};

export const AcceptedInvite: FC<AcceptedInviteProps> = ({
  eventName,
  dateStart,
  dateEnd,
  inviteAcceptionInfo,
  onChangeDecision,
  onOpenTicket,
  ticketSent,
}) => {
  const formattedDate = formatEventDate(dateStart, dateEnd);

  return (
    <div {...stylex.props(styles.content)}>
      <img src={check} alt="Приглашение принято" {...stylex.props(styles.statusIllustration)} />
      <div {...stylex.props(styles.titleContent)}>
        <p {...stylex.props(styles.titleStatus)}>Ты подтвердил участие в мероприятии</p>
        <p {...stylex.props(styles.date)}>{formattedDate}</p>
        <p {...stylex.props(styles.titleInfo)}>{eventName}</p>
      </div>
      {inviteAcceptionInfo && <p {...stylex.props(styles.subTitleInfo)}>{inviteAcceptionInfo}</p>}

      {ticketSent && (
        <div {...stylex.props(styles.actionsRow)}>
          <Button
            onClick={onOpenTicket}
            variant="secondary"
            size="medium"
            settings={{
              fontSize: '18px',
              padding: '12px 24px',
              border: `1px solid ${palette['grey-400']}`,
              color: palette.greyBlack,
            }}
          >
            Показать билет
          </Button>
        </div>
      )}

      <ChangeDecisionTrigger onClick={onChangeDecision} />
    </div>
  );
};
